import { Form, Formik } from 'formik';
import { isEmpty } from 'lodash';
import React from 'react';
import { FormElement, Label } from '@dashboard/components/Form';
import FormSubmit from '@dashboard/components/Formik/components/FormSubmit';
import { Switch, TextInput } from '@dashboard/components/Formik';
import FormError from '@dashboard/components/Formik/components/FormError';
import PageMultiSelect from '@dashboard/components/Formik/components/PageMultiSelect';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { transformApiErrorToFormik } from '@dashboard/services/form';
import usePage from '@dashboard/hooks/usePage';

const RedirectPageForm = () => {
  const { page, updatePage } = usePage();
  const { seller } = useAuth();

  return (
    <Formik
      initialValues={{
        redirect: {
          enabled: page?.redirect?.enabled || false,
          url: page?.redirect?.url || '',
        },
      }}
      onSubmit={async (values, actions) => {
        actions.setStatus(undefined);

        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.setStatus('');
          actions.resetForm({
            values: {
              redirect: data.redirect,
            },
          });
        } else {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        }
      }}
    >
      {({ values, status, dirty, handleSubmit, setFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <FormElement>
            <Switch
              label="Enable redirect"
              id="redirect.enabled"
              name="redirect.enabled"
              value={values.redirect.enabled}
              onChange={setFieldValue}
            />
            <FormError name="redirect.enabled" />
          </FormElement>

          {values.redirect.enabled && (
            <FormElement>
              <Label
                htmlFor="redirect.page"
                description="Select a checkout to redirect to or enter a URL below."
              >
                Select page
              </Label>
              <PageMultiSelect
                name="redirect.page"
                isSingle
                onChange={values => {
                  if (!values || !values[0]) return;

                  const url = `${process.env.REACT_APP_APP_URL}/c/${seller.name || seller._id}/${
                    values[0].slug
                  }`;

                  setFieldValue('redirect.url', url);
                }}
              />
            </FormElement>
          )}

          {values.redirect.enabled && (
            <FormElement>
              <Label htmlFor="redirect.url">URL to redirect to</Label>
              <TextInput
                id="redirect.url"
                name="redirect.url"
                placeholder="https://yoursite.com"
                type="url"
                required
                value={values.redirect.url}
              />
              <FormError name="redirect.url" />
            </FormElement>
          )}

          <FormElement>{status && status}</FormElement>

          <FormSubmit>
            <FormSubmit.Button>Save</FormSubmit.Button>
            <FormSubmit.State visible={!!dirty} />
          </FormSubmit>
        </Form>
      )}
    </Formik>
  );
};

export default RedirectPageForm;
